<template>
  <div class="disturb-topbar">
    <div class="disturb-topbar-top">
      <div class="topbar-operation">
        <div class="operation-left">
          <!-- 选择年级 -->
          <div class="select-class">
            选择年级：
            <el-select
              v-model="gradeValue"
              :placeholder="gradePlaceholder"
              @change="selectGrade"
              clearable
            >
              <el-option
                v-for="item in gradeSelectList"
                :key="item.gradeId"
                :label="item.gradeName"
                :value="item.gradeId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-class">
            选择班级：
            <el-select
              v-model="classValue"
              placeholder="选择班级"
              @change="selectClass"
              clearable
            >
              <el-option
                v-for="item in classSelectList"
                :key="item.classId"
                :label="item.className"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="operation-right">
          <button
            class="button add"
            @click="$emit('btnClick', 'edit')"
            v-hasPermi="'sc:disable:edit'"
          >
            免打扰编辑
          </button>
          <button
            class="button delete"
            @click="$emit('btnClick', 'clear')"
            v-hasPermi="'sc:disable:clear'"
          >
            免打扰清空
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  props: {
    gradeSelectList: {
      type: Array,
      require: true,
    },
    classSelectList: {
      type: Array,
      require: true,
    },
    gradePlaceholder: {
      type: [String, Number],
    },
  },
  data() {
    return {
      currentStatus: 1,
      disturbType: "",
      placeholder: "请输入学生名称",
      queryName: "",
      gradeValue: "",
      classValue: "",
      firstGrade: "",
    };
  },
  components: {
    search,
  },
  created() {},
  mounted() {
    // setTimeout(() => {
    //   this.gradeValue = this.gradeSelectList[0].gradeId;
    // }, 400);
  },
  methods: {
    selectGrade(e) {
      this.classValue = "";
      this.$emit("selectGrade", e);
    },
    selectClass(e) {
      this.$emit("selectClass", e);
    },
    changeStatus(value) {
      this.currentStatus = value;
      this.$emit("changeStatus", value);
    },
    // search(query) {
    //   this.queryName = query;
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "./disturb-topbar.scss";
</style>
